import { anyOf, arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, nullValidation, string } from "@altostra/type-validations/lib/primitives";

const isDomainWithStatus = objectOf({
  domain: string,
  verified: boolean,
});

const isIntegration = objectOf({
  account_name: maybe(string),
  account_email: maybe(string),
  connected_at: maybe(string),
  domains_with_status: maybe(arrayOf(isDomainWithStatus)),
  api_access_exists: maybe(boolean),
  api_version: maybe(string),
  authorization_url: maybe(string),
  show_success_modal: maybe(boolean),
  install_error: maybe(boolean),
  install_error_reason: maybe(string),
});

export const isGetAlloysPartnersGooglePostmasterAppGroupIdResult = objectOf({
  is_installed: boolean,
  integration: anyOf(isIntegration, nullValidation),
});
